import React from 'react';
import './ConfirmDialog.css';
import { AlertTriangle, X } from 'lucide-react';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isDestructive?: boolean;
  isLoading?: boolean;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isDestructive = false,
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-dialog-overlay" onClick={onClose}>
      <div className="confirm-dialog-modal" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-dialog-header">
          {isDestructive && (
            <div className="warning-icon">
              <AlertTriangle size={24} />
            </div>
          )}
          <button onClick={onClose} className="btn-close-dialog">
            <X size={20} />
          </button>
        </div>

        <div className="confirm-dialog-content">
          <h2>{title}</h2>
          <p>{message}</p>
        </div>

        <div className="confirm-dialog-footer">
          <button 
            onClick={onClose} 
            className="btn-cancel-dialog"
            disabled={isLoading}
          >
            {cancelText}
          </button>
          <button 
            onClick={onConfirm} 
            className={`btn-confirm-dialog ${isDestructive ? 'destructive' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <div className="spinner"></div>
                <span>Processing...</span>
              </>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
